export const SCHEDULES_PART02 = [
  {
    id: 'demo-sch-competitor-digest',
    title: 'Competitor news digest',
    cron: '0 18 * * *',
    enabled: true,
    apps: ['Web research', 'Slack'],
    goal:
      'Scan news, product changelogs, and pricing pages for Quantly, ChartHouse, Metricly, and Lensboard. Summarise launches, pricing changes, and notable hires, and post the digest to #market-intel.',
  },
  {
    id: 'demo-sch-support-pulse',
    title: 'Support queue pulse',
    cron: '0 * * * *',
    enabled: true,
    apps: ['Gmail', 'Slack'],
    goal:
      'Check the support@ inbox for threads unanswered for more than 2 hours or mentioning an outage, refund, or cancellation, and post a short heads-up to #support when something needs attention.',
  },
]
